/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState, useEffect } from 'react'
import { Table, Divider, Collapse, Descriptions, Spin, Select } from 'antd'
import styles from './index.less'
import moment from 'moment'

const { Panel } = Collapse;
const { Option } = Select

const Statistics = ({ info, statistics, loading, statisticsPagination, statisticsOnChange, executorList }) => {
  const [orderData, setOrderData] = useState([])
  const [executor, setExecutor] = useState('')
  const [reserveData, setReserveData] = useState([])
  const [consumption, setConsumption] = useState([])

  useEffect(() => {
    if (statistics.orderCount) {
      let newData = []
      newData.push(statistics.orderCount)
      setOrderData(newData)
    }
    if(statistics.reserveCount) {
      setReserveData([...statistics.reserveCount])
    }
    if(statistics.consumptionCount) {
      setConsumption([...statistics.consumptionCount])
    }
  }, [statistics])

  const orderColumns = [
    {
      dataIndex: 'totalQuantity',
      title: '订单总数量',
      // width: 100,
    },
    {
      dataIndex: 'totalAmount',
      title: '订单总金额',
    },
    {
      dataIndex: 'totalActualAmount',
      title: '订单应收金额',
    },
    {
      dataIndex: 'totalPaymentAmount',
      title: '已收款总金额',
      render:(text)=>{
        return text&&text.toFixed(2)
      }
    },
    {
      dataIndex: 'totalUnpaidAmount',
      title: '待支付总金额',
      render:(text)=>{
        return text&&text.toFixed(2)
      }
    },
    {
      dataIndex: 'totalServiceQuantity',
      title: '购买服务总次数',
    }
    // ,
    // {
    //   dataIndex: 'totalRiseAmount',
    //   title: '升单总金额',
    //   render:(text)=>{
    //     return text&&text.toFixed(2)
    //   }
    // },
  ]

  const reserveColumns = [
    {
      dataIndex: 'productName',
      title: '商品名称',
      // width: 100,
    },
    {
      dataIndex: 'totalQuantity',
      title: '购买总数',
    },
    {
      dataIndex: 'finishedNum',
      title: '已完成数',
    },
    {
      dataIndex: 'arrivalNum',
      title: '到店数',
    },
    {
      dataIndex: 'successNum',
      title: '预约成功数',
    },
    {
      dataIndex: 'toBeConfirmNum',
      title: '待确认数',
    },
    {
      dataIndex: 'toExecuteNum',
      title: '待执行数',
    },
  ]

  const consumptionColumns = [
    {
      dataIndex: 'orderCode',
      title: '订单ID',
      width: 100,
      ellipsis: true
    },
    {
      dataIndex: 'productName',
      title: '商品名称',
      align: 'center',
      width: 120,
      ellipsis: true
    },
    {
      dataIndex: 'totalQuantity',
      title: '购买总数',
      align: 'center'
    },
    {
      dataIndex: 'consumptionCount',
      title: '已消耗总次数',
      align: 'center'
    },
    {
      dataIndex: 'consumptionAmount',
      title: '已消耗总金额',
      align: 'center',
      render:(text)=>{
        return text&&text.toFixed(2)
      }
    },
    {
      dataIndex: 'unUsedCount',
      title: '未消耗总次数',
      align: 'center'
    },
    {
      dataIndex: 'unUsedAmount',
      title: '未消耗总金额',
      align: 'center',
      render:(text)=>{
        return text&&text.toFixed(2)
      }
    },
    {
      dataIndex: 'refundAmount',
      title: '退款金额',
      align: 'center',
      render:(text)=>{
        return text&&text.toFixed(2)
      }
    },
    {
      dataIndex: 'executorName',
      title: '执行人',
      align: 'center'
    },
  ]

  const handlePagination = (pagination, type) => {
    statisticsOnChange({...pagination, executorId: executor || null}, type)
  }

  const handleExecutor = e => {
    setExecutor(e)
    statisticsOnChange({...statisticsPagination.consumptionCount, executorId: e}, 'Consumption')
  }

  return (
    <div className={styles.statistics}>
      <Collapse style={{background: '#ffffff'}} bordered={false} defaultActiveKey={['1', '2', '3', '4']} expandIconPosition="right">
        <Panel key="1">
          <Descriptions column={4}>
            <Descriptions.Item label="建档人">{info.createdByNickname}</Descriptions.Item>
            <Descriptions.Item label="在线医助">{info.residentDoctorName}</Descriptions.Item>
            <Descriptions.Item label="心理顾问">{info.consultantDoctorName}</Descriptions.Item>
            <Descriptions.Item label="私人管家">{info.personalDoctorName}</Descriptions.Item>
            <Descriptions.Item label="主诉">{info.coreRequirement}</Descriptions.Item>
          </Descriptions>
        </Panel>
        <Panel key='2' header='订单统计'>
          <Spin spinning={!!loading.effects['personalPotentialList/queryOrderCount']}>
            {orderData && <Table
              columns={orderColumns}
              dataSource={orderData}
              size="small"
              bordered={false}
              pagination={false}
            />}
            {!orderData && <div>暂无订单统计数据</div>}
          </Spin>
        </Panel>
        <Panel key='3' header='预约统计'>
          <Spin spinning={!!loading.effects['personalPotentialList/queryReserveCount']}>
            <Table
              columns={reserveColumns}
              dataSource={reserveData}
              size="small"
              bordered={false}
              pagination={{
                ...statisticsPagination.reserveCount,
                // statisticsOnChange
              }}
              onChange={pagination => handlePagination(pagination, 'Reserve')}
            />
          </Spin>
        </Panel>
        <Panel key='4' header='消耗统计' disabled showArrow={false} extra={<Select value={executor}
         style={{width: 100}} onChange={e => handleExecutor(e)} size='small' >
            <Option value=''>所有人</Option>
            {executorList && executorList.map(_ => <Option value={_.executorId}>{_.executorName}</Option>)}
        </Select>}>
          <Spin spinning={!!loading.effects['personalPotentialList/queryConsumptionCount']}>
            <Table
              columns={consumptionColumns}
              dataSource={consumption}
              size="small"
              rowKey='orderId'
              bordered
              pagination={{
                ...statisticsPagination.consumptionCount,
              }}
              onChange={pagination => handlePagination(pagination, 'Consumption')}
              // summary={() => {
              //   return (<Table.Summary.Row>
              //       <Table.Summary.Cell index={0}>汇总消耗</Table.Summary.Cell>
              //       <Table.Summary.Cell>--</Table.Summary.Cell>
              //       <Table.Summary.Cell>汇总消耗</Table.Summary.Cell>
              //       <Table.Summary.Cell>--</Table.Summary.Cell>
              //       <Table.Summary.Cell>汇总消耗</Table.Summary.Cell>
              //       <Table.Summary.Cell>--</Table.Summary.Cell>
              //       <Table.Summary.Cell>汇总消耗</Table.Summary.Cell>
              //       <Table.Summary.Cell>--</Table.Summary.Cell>
              //     </Table.Summary.Row>)
              // }}
            />
          </Spin>
        </Panel>
      </Collapse>
    </div>
  )
}

export default Statistics